import { Navigate } from "react-router-dom";

const RoleProtectedRoute = ({ children, allowedRoles = [] }) => {
    const role = localStorage.getItem("role");
    const userRole = parseInt(role);

    // If no allowed roles specified, allow all authenticated users
    if (allowedRoles.length === 0) {
        return children;
    }

    // Check if user's role is in the allowed roles array
    if (allowedRoles.includes(userRole)) {
        return children;
    }
    if(role==3||role==7){

        return <Navigate to="/dashboard" replace />;
    }else{
        return <Navigate to="/all-bookings" replace />;
    }
};

export default RoleProtectedRoute;